var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_13684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4762 21.7335C32.1386 31.1084 22.6422 36.8139 13.265 34.4761C3.89168 32.1387 -1.81447 22.6429 0.524214 13.2685C2.86071 3.8924 12.3571 -1.81364 21.7316 0.52368C31.1082 2.861 36.8138 12.3579 34.4762 21.7335Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2174 15.0067C25.5658 12.6781 23.7926 11.4264 21.3681 10.5913L22.1546 7.43694L20.2343 6.95843L19.4686 10.0296C18.9638 9.90387 18.4453 9.7852 17.9301 9.66762L18.7012 6.57617L16.782 6.09766L15.995 9.25091C15.5772 9.15575 15.167 9.06169 14.7688 8.96271L14.771 8.95286L12.1227 8.2917L11.6119 10.3425C11.6119 10.3425 13.0366 10.6689 13.0066 10.6892C13.7843 10.8833 13.9249 11.3979 13.9013 11.8059L13.0055 15.3994C13.0591 15.413 13.1285 15.4327 13.2051 15.4633C13.1411 15.4475 13.0727 15.43 13.0022 15.413L11.7464 20.447C11.6513 20.6832 11.4101 21.0376 10.8664 20.9031C10.8856 20.931 9.47064 20.5547 9.47064 20.5547L8.51733 22.7526L11.0163 23.3755C11.4812 23.4919 11.9368 23.6139 12.3852 23.7287L11.5906 26.9192L13.5086 27.3977L14.2957 24.2412C14.8196 24.3833 15.3283 24.5146 15.826 24.6382L15.0417 27.7799L16.962 28.2585L17.7567 25.074C21.0312 25.6936 23.4935 25.4437 24.5299 22.4824C25.3651 20.0981 24.4883 18.7227 22.7655 17.8258C24.0202 17.5365 24.9653 16.7113 25.2174 15.0067ZM20.8299 21.1584C20.2365 23.5428 16.2214 22.2538 14.9197 21.9306L15.9742 17.7039C17.2759 18.0287 21.4501 18.6718 20.8299 21.1584ZM21.4239 14.9723C20.8824 17.1411 17.5406 16.0392 16.4566 15.769L17.4127 11.9355C18.4967 12.2056 21.9878 12.7099 21.4239 14.9723Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_13684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.9d16eb261a40c089e642d91ed41b1cd1.svg";
export { ForwardRef as ReactComponent };